import { ModalBox, StyledButton } from './styles';

import Icon from '@icons';
import Modal from '@material-ui/core/Modal';
/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';
/**
 * ReactDOM é um pacote que fornece métodos específicos do DOM que podem
 * ser usados no nível superior do seu aplicativo e como uma saída de 
 * emergencia para sair do modelo React.
 */
import ReactDOM from 'react-dom';

/**
 * ReactDOM.render() função recebe dois argumentos, codigo HTML e um 
 * elemento html, a função tem como objetivo exibir o codigo HTML espe-
 * cificado dentro do elemento HTML especificado.
 */
const onClose = () => {
  ReactDOM.render(null, document.getElementById('alert'));
};

/**
 * Confirm é um substituto do window.confirm() nativo do javascript com
 * a diferença de que esse está estilizado em um modal com a identidade
 * visual do projeto. Apenas um confirm por vez pode ser disparado e ele
 * pode ter um callback ao confirmar.
 */
export const Confirm = ({
  title,
  message,
  buttonText,
  callback,
  finallyCallback,
  gap,
}) => {
  const closeAndCallback = (boolean) => {
    if (boolean === true && callback && typeof callback === 'function') {
      callback(true);
    }
    if (boolean === false || typeof boolean === 'undefined') {
      callback(false);
    }
    if (finallyCallback && typeof finallyCallback === 'function') {
      finallyCallback();
    }
    onClose();
  };

  /**
   * Estrutura do componente Confirm modal com
   * identidade visual do projeto
   */
  return (
    <Modal style={{ zIndex: 2000 }} open={true} onClose={closeAndCallback}>
      <ModalBox>
        <button onClick={closeAndCallback} className="close">
          <Icon i="all-close" />
        </button>
        <header>
          <h2>{title || 'GEOBAHIA informa:'}</h2>
        </header>
        <div className="content">{message && <p>{message}</p>}</div>
        <footer style={{columnGap: gap}}>
          <StyledButton
            variant="contained"
            color="secondary"
            onClick={closeAndCallback}
          >
            Cancelar
          </StyledButton>
          <StyledButton
            variant="contained"
            color="primary"
            onClick={() => closeAndCallback(true)}
          >
            {buttonText || 'OK'}
          </StyledButton>
        </footer>
      </ModalBox>
    </Modal>
  );
};

Confirm.propTypes = {
  /** Titulo do Confirm */
  title: PropTypes.string.isRequired,
  /** Mensagem do Confirm */
  message: PropTypes.string.isRequired,
  /** Função de callback: `function(confirmed)` */
  callback: PropTypes.func,
  /** Função de callback que executara independente da confirmação */
  finallyCallback: PropTypes.func,
  /** Texto do botão do Confirm */
  buttonText: PropTypes.string,
};

export default Confirm;
